import { css } from '@emotion/react';
import {
  Box,
  Flex,
  Title,
  VisuallyHidden,
  desktopFirstMediaQuery,
  rem,
} from '@inflearn/ds-react-next';
import type { ParseKeys } from 'i18next';
import { useTranslation } from 'next-i18next';
import type { ReactNode } from 'react';

import AppShellLayoutForCSR from '../AppShellLayoutForCSR';
import type { CustomHeadProps } from '../CustomHead';
import CustomHead from '../CustomHead';
import { DefaultGuard } from '../DefaultLayout';

interface FaqLayoutProps {
  children: ReactNode;
  meta: CustomHeadProps & { title: ParseKeys; description: ParseKeys };
  guard?: ({ children }: { children: ReactNode }) => JSX.Element;
}

const FaqLayout = ({ guard: Guard = DefaultGuard, children, meta }: FaqLayoutProps) => {
  const { t } = useTranslation();

  return (
    <Guard>
      <CustomHead
        {...meta}
        title={t(meta.title)}
        siteTitle={t('인프런')}
        description={t(meta.description)}
        pageCategory={t('메타.고객센터.페이지카테고리')}
      />
      <AppShellLayoutForCSR requiredLogin={false} showChanneltalk>
        <Box
          component="main"
          mih="100vh"
          mx={32}
          css={{
            [desktopFirstMediaQuery.mobile]: {
              margin: `0 ${rem(16)}`,
            },
          }}
        >
          <VisuallyHidden>
            <Title order={1}>{meta?.title || t('인프런')}</Title>
          </VisuallyHidden>
          <Flex
            direction="column"
            w="100%"
            my={0}
            mx="auto"
            maw={944}
            styles={{
              root: styleMainContentWrapper,
            }}
          >
            {children}
          </Flex>
        </Box>
      </AppShellLayoutForCSR>
    </Guard>
  );
};

const styleMainContentWrapper = css({
  flex: '1 1 0',

  [desktopFirstMediaQuery.tablet]: {
    maxWidth: rem(716),
  },
});

export default FaqLayout;
